<template>
  <div
    class="crop-area flex absolute inset-0 overflow-y-auto"
    style="z-index: 500; max-width:100%; max-height:100%;"
  >
    <!-- トリミング元画像 -->
    <div
      class="inline-block"
      style="height:600px; width:600px; min-height:600px; min-width:600px; margin-top:auto;margin-bottom:auto; margin-left:auto;"
    >
      <span
        :class="
          `absolute inline-block cropper-header-border text-lg mr-4 text-white bg-${color}`
        "
        style="border-radius:8px 8px 0 0; height:30px; width:160px; margin-top:-30px; text-align:center;"
        >画像切り抜き編集</span
      >
      <img id="cropper-img" :src="source" />
      <!-- メニューボタン -->
      <div class="absolute" style="margin-top:-600px; margin-left:500px;">
        <button
          class="block cropper-button text-white ml-1 mt-1"
          style="height:30px; width:90px;"
          type="button"
          @click="rightRollImage"
        >
          右回転
        </button>
        <button
          class="block cropper-button text-white ml-1 mt-1"
          style="height:30px; width:90px;"
          type="button"
          @click="leftRollImage"
        >
          左回転
        </button>
        <button
          class="block cropper-button text-white ml-1 mt-1"
          style="height:30px; width:90px;"
          type="button"
          @click="trimImage"
        >
          切り抜き
        </button>
      </div>
    </div>
    <!-- トリミング後画像 -->
    <div
      class="inline-block ml-1"
      style="margin-top:auto; margin-bottom:auto; margin-right:auto; background:gray;"
    >
      <div class="flex block cropper-border" style="height:600px; width:504px;">
        <span v-if="!CropResult" class="text-white">
          ※切り抜き後の画像がここに表示されます。
        </span>
        <div style="margin:auto;">
          <img style="max-height:596px; max-width:500px;" :src="CropResult" />
        </div>
        <!-- メニューボタン -->
        <div class="absolute" style="margin-left: 402px;">
          <button
            class="block cropper-end-button text-white ml-1 mr-1 mt-1"
            style="height:30px; width:90px;"
            type="button"
            @click="saveImage"
          >
            完了
          </button>
          <button
            class="block cropper-end-button text-white ml-1 mr-1 mt-1"
            style="height:30px; width:90px;"
            type="button"
            @click="closeImgEditor"
          >
            キャンセル
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { useImgUploader } from '@/services/useImgUploader'
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'

export default {
  name: 'AppImageCropper',

  components: {},
  props: {
    source: String,
    index: Number,
    type: String,
    color: String,
  },
  setup(props) {
    let obj = ref([])
    let CropResult = ref('')
    let trimImageSrc = ref('')
    let { closeImgEditor, putTrimImage } = useImgUploader()
    onMounted(() => {
      obj.value = []
      CropResult.value = ''
      trimImageSrc.value = ''
      const cropperImg = document.getElementById('cropper-img')
      const cropper = new Cropper(cropperImg)
      obj.value = cropper
      // Cropperの表示モードの設定。1は切り取り枠が画像外に出ない(初期値:0 制限なし)
      obj.value.options.viewMode = 1
      // ウインドウサイズ変更時にトリミングされた領域を復元するかどうかを設定。(trueだと挙動がおかしいのでfalseにする)
      obj.value.options.restore = false
      // マウスホイールのズーム速度を変更(初期値:0.1)
      obj.value.options.wheelZoomRatio = 0.15
      // トリミングボックス外の切り抜き画像をドラッグした時の動作を設定。(初期は'crop')
      obj.value.options.dragMode = 'move'
    })

    const trimImage = () => {
      //base64jpeg形式でトリミングした画像をプレビューに表示する
      const resultImgUrl = obj.value
        .getCroppedCanvas()
        .toDataURL('image/jpeg', 0.85)
      CropResult.value = resultImgUrl
      trimImageSrc.value = resultImgUrl
    }

    const saveImage = () => {
      //プレビューに表示されている画像を入力フォームへ上書きする。
      const resultImgUrl = obj.value
        .getCroppedCanvas()
        .toDataURL('image/jpeg', 0.85)
      CropResult.value = resultImgUrl

      putTrimImage(
        trimImageSrc.value == '' ? resultImgUrl : trimImageSrc.value,
        props.index,
        props.type,
      )
      closeImgEditor()
    }

    const rightRollImage = () => {
      // 数値変更で回転ボタンを押したときに設定した角度だけ画像を回転させる。負の数値で逆回転
      obj.value.rotate(5)
    }
    const leftRollImage = () => {
      obj.value.rotate(-5)
    }

    return {
      obj,
      CropResult,
      trimImageSrc,
      closeImgEditor,
      putTrimImage,
      trimImage,
      rightRollImage,
      leftRollImage,
      saveImage,
    }
  },
}
</script>
<style lang="scss">
.cropper-container {
  border: solid 2px #fff;
}
.cropper-border {
  border: solid 2px #fff;
}
.cropper-header-border {
  border: solid 2px #fff;
  border-bottom: none;
}
.cropper-button {
  text-decoration: none;
  background: #549a1d50;
  // border: double 4px #fff;
  border: solid 2px #ffffff50;
  border-radius: 3px;
  transition: 0.4s;
}
.cropper-end-button {
  text-decoration: none;
  background: #549a1d50;
  border: double 4px #ffffff50;
  border-radius: 3px;
  transition: 0.4s;
}
.cropper-end-button:hover {
  background: #549a1d;
  border: double 4px #ffffff;
}
.cropper-button:hover {
  background: #549a1d;
  border: solid 2px #ffffff;
}
.cropper-point.point-se {
  height: 20px;
  width: 20px;
  bottom: -10px;
  right: -10px;
}
.cropper-point.point-sw {
  height: 20px;
  width: 20px;
  bottom: -10px;
  left: -10px;
}
.cropper-point.point-nw {
  height: 20px;
  width: 20px;
  left: -10px;
  top: -10px;
}
.cropper-point.point-ne {
  height: 20px;
  width: 20px;
  right: -10px;
  top: -10px;
}
.cropper-point.point-e {
  height: 10px;
  width: 10px;
  bottom: -5px;
}
.cropper-point.point-n {
  height: 10px;
  width: 10px;
  top: -5px;
}
.cropper-point.point-w {
  height: 10px;
  width: 10px;
  left: -5px;
}
.cropper-point.point-s {
  height: 10px;
  width: 10px;
  right: -5px;
}
.cropper-line {
  opacity: 0;
}
.cropper-line.line-e {
  width: 20px;
}
.cropper-line.line-n {
  height: 20px;
}
.cropper-line.line-w {
  width: 20px;
}
.cropper-line.line-s {
  height: 20px;
}
</style>
